import React from 'react';
import './panel.scss'
import {NavElement} from "../NavElement";

export const Panel = () => {
    return (
        <div className='panel'>
            <NavElement/>
        </div>
    );
};